import { render, staticRenderFns } from "./CustomAccountTransactionLabel.vue?vue&type=template&id=6e61804a"
import script from "./CustomAccountTransactionLabel.vue?vue&type=script&lang=js"
export * from "./CustomAccountTransactionLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports